import { Button, DataLayerHelper } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import './banner-social-network.component.scoped.scss'
import { useMemo } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onClick?: (e?: any) => any
  hiddenText?: boolean
}

export default ({ className = '', onClick, hiddenText = false }: Props) => {
  const [t] = useTranslation('bannerSocialNetwork')
  const dataLayerHelper = useMemo(() => new DataLayerHelper(), [])

  const handleClick = (event: any) => {
    if (onClick && typeof onClick === 'function') {
      dataLayerHelper?.sendToDataLayer({
        event: 'social_network_session',
        step: 'Conectar rede social',
        action: 'next',
        description: 'coleta click para modal redes',
      })
      onClick(event)
    }
  }

  return (
    <div className={`banner-social-network ${className}`}>
      {!hiddenText ? <p dangerouslySetInnerHTML={{ __html: t('text') }} /> : null}
      <Button
        id="banner-social-network-button"
        data-testid="banner-social-network-button"
        onClick={(e: any) => handleClick(e)}
        color="primary"
        size="sm"
      >
        <i className="mr-1 fa-regular fa-link"></i>
        {t('button')}
      </Button>
    </div>
  )
}
